import * as React from 'react';

interface Props {
  ariaName?: string;
  width?: number;
  height?: number;
  color: string;
}

export const ClearIcon: React.FunctionComponent<Props> = ({
  ariaName,
  width = 10,
  height = 10,
  color,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ariaName}</title>
      <path d="M1 1L9 9" stroke={color} />
      <path d="M9 1L1 9" stroke={color} />
    </svg>
  );
};
